var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQGift = function SvgQGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.539,
    height: 13.631,
    x: 2.73,
    y: 3.869,
    fill: "#7B69DE",
    rx: 1.636
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C0B3F9",
    d: "M8.637 3.869h2.726V17.5H8.637z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0B3F9",
    d: "M5.457 1.876c0-.365.352-.627.702-.522L10 2.507l3.841-1.153a.545.545 0 0 1 .702.522V3.87H5.457z"
  })));
};
export { SvgQGift as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJjdXJyZW50Q29sb3IiPgo8cmVjdCB4PSIyLjczMDQ3IiB5PSIzLjg2OTE0IiB3aWR0aD0iMTQuNTM5NCIgaGVpZ2h0PSIxMy42MzA3IiByeD0iMS42MzU2OCIgZmlsbD0iIzdCNjlERSIvPgo8cmVjdCB4PSI4LjYzNjcyIiB5PSIzLjg2OTE0IiB3aWR0aD0iMi43MjYxNCIgaGVpZ2h0PSIxMy42MzA3IiBmaWxsPSIjQzBCM0Y5Ii8+CjxwYXRoIGQ9Ik01LjQ1NzAzIDEuODc2MzZDNS40NTcwMyAxLjUxMTEzIDUuODA5MSAxLjI0OTE4IDYuMTU4OTMgMS4zNTQxMkwxMC4wMDA2IDIuNTA2NjJMMTMuODQyMyAxLjM1NDEyQzE0LjE5MjEgMS4yNDkxOCAxNC41NDQxIDEuNTExMTMgMTQuNTQ0MSAxLjg3NjM2VjMuODY5NjlINS40NTcwM1YxLjg3NjM2WiIgZmlsbD0iI0MwQjNGOSIvPgo8L3N2Zz4=";